module.exports = __webpack_public_path__ + "static/img/Jaxon-Purdue.f549a7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jaxon-Purdue.jpg
// module id = 6mjb
// module chunks = 0